import React from 'react';
import '../auth.css';
import i18n from '../i18n';
import {connect} from 'react-redux'
import axios from 'axios';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import {  TextArea } from 'semantic-ui-react'
import {reactLocalStorage} from 'reactjs-localstorage';
import { API_BASE_URL } from "../utils/endpoints";

class FormContactType extends React.Component
 {
   constructor(props)
    {
       super(props);
       this.state = { name: '' };
       this.state={mobile_number :''};
       this.state = { email: '' };
       this.state={question :''};
   }

   componentWillMount() {
       this.setState({name :reactLocalStorage.get('user_name')})
       this.setState({mobile_number :reactLocalStorage.get('user_phone')})
       this.setState({email :reactLocalStorage.get('user_email')})
       this.setState({question :'What about '+reactLocalStorage.get('user_type')+'?'})
    if( reactLocalStorage.get('lang') ==='ar')
  {
    i18n.changeLanguage('ar');
  }
  else{
    i18n.changeLanguage('en');
  }
  
  
  }

    submitForm=(e)=> {
      e.preventDefault();
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if(ip.includes(s2))
      {
        apiBaseUrl = API_BASE_URL + "/core/corpsms/contactus";
      }
      else
      {
       apiBaseUrl = ip +"/core/corpsms/contactus";
      }
      var data={
        'name':this.state.name,
        'mobile_number':this.state.mobile_number,
        'email':this.state.email,
        'question':this.state.question
      };
      var headers = {
             'content-type': 'application/json',
             
         }
      axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
      {
      
        if(response.status === 200)
        {
           if(response.data.status === 'success')
           {
            if(response.data.result.message)
             {   
              toast({
                type: 'success',
                title: i18n.t('success.label'),
                description: response.data.result.message,
                animation: 'bounce',
                time: 5000,
               
            });
            window.location="/app"
      
             }

    }
  }
  else
  {
  /*  toast({
      type: 'error',
      title: 'error',
      description: response.data.result.errorReposne,
      animation: 'bounce',
      time: 5000,
     
  });*/
  }
})
    }



    onInputChange=(event)=>
    {
      this.setState({name:event.target.value});
    }

    onNumberChange=(event)=>
    {
      this.setState({mobile_number:event.target.value});
    
    }
    onEmailChange=(event)=>
    {
      this.setState({email:event.target.value});
     
    }

    onQuestionChange=(event)=>
    {
      this.setState({question:event.target.value});
     
    }

   render () {
   return (
     <div>
     <form className="ui large form border radius content_form">
     <div className="stacked segment border_margin">



 




<div className="reset_check_code" style={{display:'block'}}>
<div className="field">
     <div className="ui fluid left icon input">
     <input placeholder={i18n.t('Name.label')}  type="text" className="username" value={this.state.name} onChange={this.onInputChange}/>
     <i aria-hidden="true" className="user icon" style={{color:'#2ed9c3'}}></i>
     </div></div>
     <div className="field">
     <div className="ui fluid left icon input">
     <input placeholder={i18n.t('Mobile_Number.label')} type="number" className="username" value={this.state.mobile_number} onChange={this.onNumberChange}/>
     <i aria-hidden="true" className="mobile icon" style={{color:'#2ed9c3'}}></i>
     </div></div>
     <div className="field">
    <div className="ui fluid left icon input">
    <input placeholder={i18n.t('email.label')} type="email" className="username" value={this.state.email} onChange={this.onEmailChange}/>
    <i aria-hidden="true" className="mail icon " style={{color:'#2ed9c3'}}></i>
    </div></div>

      <div className="field">
      <div className="ui fluid left icon input">


<TextArea placeholder={i18n.t('your_question.label')} rows="2" className="username" onChange={this.onQuestionChange}
                        value={this.state.question}></TextArea>
      </div></div>

    <button className="ui large fluid button btn_login radius" onClick={this.submitForm.bind(this)}>{i18n.t('Submit.label')}</button>
</div>







<SemanticToastContainer/>

     </div>
     </form>
     </div>
          );
      }
   }


const mapStateToProps = (state)=>{
  return {...state}
}

export default connect(mapStateToProps)(FormContactType);




